export default __webpack_public_path__ + "static/home-references-bg-e5589d072234921a5a692c63944075f3.png";